<template>
  <div class="phoneLoginPage" :style="{height: scrollerHeight}">
    <Header></Header>
    <!-- banner -->
    <div class="loginBox">
      <div class="header">
        <img class="titlePic" height="28px" src="../../../assets/picture/product/loginTitle.png">
        <img class="headerPic" height="100%" src="../../../assets/picture/product/t13.png">
      </div>
      <div class="contain">
        <div class="inputBox">
          <span class="title">{{$t('productIndex.userName')}}</span>
          <input type="text" v-model="loginForm.username" :placeholder="$t('productIndex.userNamePlaceholder')" >
        </div>
        <div class="inputBox">
          <span class="title">{{$t('productIndex.password')}}</span>
          <input type="password"  v-model="loginForm.password" :placeholder="$t('productIndex.passwordPlaceholder')" >
        </div>
      </div>
      <div class="footer">
        <div class="loginNow" @click="login">{{$t('productIndex.loginNow')}}</div>
        <!-- <div class="forgetPass">{{$t('productIndex.forget')}}</div> -->
      </div>
    </div>
    <div class="footerBox phoneShow">
        <div class="container">
          <p>&copy;{{copyright}}</p>
          <p>(<a target="_blank" href="http://beian.miit.gov.cn/">{{icpNumber}}</a>）</p>
        </div>
    </div>
    <!-- footer -->
<!--     <Footer></Footer> -->
  </div>
</template>

<script>
import Header from '../../common/header';
// import Footer from '../../common/footer';
export default {
  data() {
    return {
      copyright:'',
      icpNumber:'',
      mytoken:'',
      isShowSearch:false,
      scrollerHeight:'',
      loginForm: {
        username: "",
        password: ""
      },
      //表单验证规则对象
      loginFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ]
      },
    };
  },
  components: { Header },
  mounted(){
    this.getConfig();
    this.mytoken = window.sessionStorage.getItem("token")?window.sessionStorage.getItem("token"):'';
    this.scrollerHeight = (window.innerHeight-60) + 'px';
  },
  methods: {
    // 登录
    async login() {
        const { data: res } = await this.$http.post("/member/login.do?password="+this.loginForm.password+"&username="+this.loginForm.username);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("登录成功");
        let id = res.data.id;
        this.$router.push({  
            path: 'productDetail',   
            query: {   
                id: id,   
            }      
        })
        // 保存token到sessionStorage，写入token键
        window.sessionStorage.setItem("token", res.data.token);
        window.sessionStorage.setItem("id", res.data.id);
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     //获取基础配置信息
    async getConfig() {
        const { data: res } = await this.$http.get("/config/getConfig.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.copyright = res.data.copyright;
        this.icpNumber = res.data.icpNumber;
      },
  }
};
</script>

<style lang="less" scoped>
.phoneLoginPage{
  width: 100%;
  height: 100%;
  background: #F0F2F5;    
  .loginBox{
    padding-top: 10rem;
    .header{
      width: 100%;
      height: 18.2rem;
      background: #353535;
      .titlePic{
        margin:6.5rem;
        height: 5rem;
      }
      .headerPic{
        float: right;
      }
    }
    .contain{
      background: #F0F2F5;
      padding:0 4rem;
      .inputBox{
        padding:11.2rem 0;
        border-bottom: 1px solid #D5D5D5;
        background: #F0F2F5;
        .title{          
          font-size: 2.8rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #9A9A9A;
          line-height: 4rem;
          margin-right: 3.2rem;
        }
        input{
          border:none;        
          font-size: 2.8rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 4rem;
          outline:none;
          background: #F0F2F5;
        }
      }
    }
    .footer{
      background: #F0F2F5;
      padding: 10rem 0;
      .loginNow{
        width: 40.6rem;
        height: 8rem;
        background: #900211;    
        font-size: 2.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F2F2F2;
        line-height: 8rem;
        letter-spacing: 2rem;
        text-align: center;
        margin:0 auto;
      }
      .forgetPass{
        margin-top: 4rem;       
        font-size: 2.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9A9A9A;
        line-height: 4rem;
        letter-spacing: 1rem;
        text-align: center;
        margin-bottom: 30.8rem;
      }
    }
  }
}
.footerBox{
  width: 100%;
  background: #1E1E1E;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F2F2F2;
  line-height: 20px;
  padding:20px 18px;
  position: fixed;
  bottom: 0;
  a,a:hover{
      font-weight: 500;
      color: #F2F2F2;
    }
}
</style>
